import FieldMapping from './fieldMappingTab.container';

export default FieldMapping;
